import Header from "../blocks/header";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Copyright from "../blocks/copyright";
import Box from "@mui/material/Box";
import {useNavigate, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import TextField from "@mui/material/TextField";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {editOneOrder, getOneOrder, messageReset} from "../store/orders";
import {getAllVerifyResponse} from "../store/logIn";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ImageModal from "../blocks/imageModal";

function EditOrder(props){
    const [confirmed, setConfirmed] = useState('confirmed_yes'); // Bazadan kelayotgan ma'lumot
    const navigate = useNavigate()
    const toBack = () => {
        navigate(-1);
    }
    const params = useParams()
    const [single_order, setSingleOrder] = useState('')

    useEffect(()=>{
        props.getOneOrder(params.id)
    }, [])

    useEffect(()=>{
        setSingleOrder(props.orders_single)
    }, [props.orders_single])

    function saveFormData(e) {
        e.preventDefault()
        const data = {
            "id": params.id,
            "confirmed": confirmed,
            "website": true,
        }
        console.log(data, 111)
        props.editOneOrder(data)
    }


    useEffect(() => {
        if (props.message === true) {
            navigate('/orders/')
        } else if (props.message === 'error') {
            toast.error('Xatolik!', {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])

    return <div>
        <div className={'page'}>
            <Header/>
            <Dashboard/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                }}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon />} onClick={toBack}>
                        {'Ortga'}
                    </Button>
                    <h2 className={'page-title text-center'}>{'Tolovni tasdiqlash'}</h2>
                    <form className={'add-form add-document'} onSubmit={saveFormData} encType={'multipart/form-data'}>
                        <p>
                            <span>{'Buyurtma kodi'}:</span>
                            <TextField
                                value={single_order['code']}
                                disabled
                                type={"text"}
                                variant="outlined"
                            />
                        </p>
                        <p>
                            <span>{'Partiya raqami'}:</span>
                            <TextField
                                value={single_order['serial_number']}
                                disabled
                                type={"text"}
                                variant="outlined"
                            />
                        </p>
                        <p>
                            <span>Umumiy summa ($):</span>
                            <TextField
                                value={single_order['all_sum_dollar']}
                                disabled
                                type={"text"}
                                variant="outlined"
                            />
                        </p>
                        <p>
                            <span>Umumiy summa (so'mda):</span>
                            <TextField
                                value={single_order['all_sum_sum']}
                                disabled
                                type={"text"}
                                variant="outlined"
                            />
                        </p>
                        <p className={'image-p'}>
                            <span>To'lov skrinshotlari:</span>
                            {single_order['photos'] ? single_order['photos'].map((photo, index) => (
                                <ImageModal src={photo['photo']} alt={photo.id} />
                            )) : ''
                            }

                        </p>
                        <div className={'buttons'}>
                            <Button type={'submit'} onClick={()=>setConfirmed('confirmed_no')} style={{width: '100%'}} variant="contained"
                                    fullWidth color={'error'}>
                                TO'LOVDA XATOLIK
                            </Button>
                            <Button type={'submit'} style={{width: '100%'}} variant="contained"
                                    fullWidth color={'info'}>
                                TO'LOVNI TASDIQLASH
                            </Button>
                        </div>
                    </form>
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.orders, {
    editOneOrder,
    getOneOrder,
    getAllVerifyResponse,
    messageReset
})(EditOrder)